<template>
  <div class="section-panel text-center">
    <div class="container-fluid">
      <div class="title">
        <h3>{{$t('settings.roles')}}</h3>
      </div>
      <div class="text-left">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/panel/settings?active=roles' }">Roles</el-breadcrumb-item>
            <el-breadcrumb-item>{{modeForm}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="col-md-8 ml-auto mr-auto">
        <div class="card plain">
            <div class="card-body">
            <form id="form-role" role="form" @submit.prevent="onFormSubmit">
                <div class="title">
                  
                </div>
                <el-divider></el-divider>
                <div class="row p-2">
                    <div class="col-md-12">
                        <fg-input
                            label="Name"
                            class="has-label input-lg"
                            v-model="formData.name"
                        ></fg-input>
                    </div>
                </div>

                <el-divider></el-divider>
                
                <div class="card-footer text-center">
                    <router-link
                        class="btn text-white btn-round btn-default"
                        to="/panel/settings?active=roles">
                        {{$t('settings.button_cancel')}}
                    </router-link>
                    &nbsp;
                    <el-button size="medium" type="info" round native-type="submit">
                        {{$t('settings.button_save')}}
                    </el-button>
                </div>
                

            </form>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Card, FormGroupInput } from '@/components';
import { DatePicker,Breadcrumb, BreadcrumbItem, Divider, Input, Button, MessageBox, Message, Select, Option } from 'element-ui';
import _ from 'lodash'

import Settings from '@/providers/Settings'
const provider = new Settings()

export default {
  name: 'role-form',
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Input.name]: Input,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    [Divider.name]: Divider,
    [Select.name]: Select,
    [Option.name]: Option
  },
  data() {
    return {
        loading: false,
        formData: {
          name: null
        },
        modeForm: 'New'
    }
  },
  mounted() {
    this.getRole()
  },
  computed: {
    
  },
  methods: {
    onFormSubmit () {
      this.loading = true
      let id = this.$route.params.id
      if (id) {
        console.info(JSON.stringify(this.formData))
        provider.patchRole(id, this.formData).then((response) => {
          this.error = null
          Message({
            type: 'success',
            message: 'Operación exitosa'
          })
          setTimeout(() => {
              this.loading = false
              this.$router.push('/panel/settings?active=roles')
          }, 1000);
        }).catch((err) => {
          console.info('error post roles request')
          console.info(err)
        })
      } else {
        provider.postRole(this.formData).then((response) => {
          this.error = null
          Message({
            type: 'success',
            effect: 'dark',
            message: 'Operación exitosa'
          })
          setTimeout(() => {
              this.loading = false
              this.$router.push('/panel/settings?active=roles')
          }, 1000);
        }).catch((err) => {
          Message({
            type: 'warning',
            message: 'No se guardó la información, intente nuevamente'
          })
          console.info('error post users request')
          console.info(err)
        })
      }
    },
    getRole() {
      if (this.$route.params && this.$route.params.id) {
        this.modeForm = 'Edit'
        let id = this.$route.params.id
        provider.getRole(id).then((response) => {
          console.info('get role response')
          let data = response.data.data
          if(data && data.attributes) {
            this.formData.id = data.id
            this.formData.name = data.attributes.name
          }
        }).catch((err) => {
          console.info('error get role request')
          console.info(err)
        })
      }else {
        this.modeForm = 'New'
      }
    },
    handleRolSelected() {

    }
  },
  watch: {
  }
};
</script>
<style>
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  .demo-input-label {
    text-align: center !important;
    display: block;
    padding: 5px !important;
  }
</style>